<template>
    <div class="container">
        <div class="head">
            <img src="../assets/img/title.png"/>
            <div class="chinese-title">{{chineseTitle}}</div>
            <div class="line"></div>
        </div>
        <div class="english-title">{{englishTitle}}</div>
        <div class="body">
            <slot name="test"/>
        </div>
    </div>
</template>


<script>
    export default {
        name: "Title",
        props: {
            chineseTitle: String,
            englishTitle: String
        },
    };
</script>

<style scoped lang="less">
    .container {
        width: 4200/192vw;
    }

    .head {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .chinese-title {
        margin-left: 160/192vw;
        color: #e6f3fdff;
        font-size: 18rem;
        word-break: keep-all;
    }

    .line {
        width: 5000/192vw;
        height: 10/108vh;
        background: #ffc341;
        margin-left: 130/192vw;
    }

    .english-title {
        font-size: 14rem;
        color: #E6F3FD;
        margin-left: 330/192vw;
        white-space: nowrap;
    }

    .body {
        margin-left: 192/192vw;
        width: 4000/192vw;
        margin-top: 120/108vh;
        overflow: hidden;
    }

</style>
